import './Privacy.css';

export function Privacy() {
  return (
    <div className="privacy">
      <h1>Política de Privacidade</h1>
      <div className="content">
        <p>Nossa política de privacidade...</p>
      </div>
    </div>
  );
} 